exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".site-bignightin header[role=banner].header #block-branding .site-logo {\n  width: 100%; }\n  .site-bignightin header[role=banner].header #block-branding .site-logo img {\n    width: 100%; }\n  @media screen and (min-width: 740px) {\n    .site-bignightin header[role=banner].header #block-branding .site-logo {\n      width: 550px; }\n      .site-bignightin header[role=banner].header #block-branding .site-logo img {\n        width: 550px; } }\n", ""]);

// exports
